import { all, call } from 'redux-saga/effects';
import { getAppList } from '../lib/appsRegistry';
import controlSaga from '../controls/saga';

const buildRootSaga = async ({ companyName } = {}) => {
  const appList = await getAppList({ companyName });
  const sagaList = [call(controlSaga)];
  appList.forEach(app => {
    const { getSagas } = app;
    if (typeof getSagas === 'function') {
      const sagasToAdd = app.getSagas();
      sagasToAdd.forEach(saga => {
        sagaList.push(call(saga));
      });
    }
  });

  const rootSaga = function* rootSaga() {
    yield all(sagaList);
  };

  return rootSaga;
};

export default buildRootSaga;
